<template>
    <el-dialog v-dialogDrag class="dialog" width="1080px" :visible.sync="dialogVisible" v-loading="dialoading" :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑员工信息
            </div>
        </div>
        <div class="dialog_body">
            <el-tabs style="padding: 0 20px" v-model="activeName">
                <el-tab-pane name="first">
                    <span slot="label"><i class="el-icon-date"></i> 员工信息 </span>
                    <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                             label-width="120px">
                        <el-form-item label="姓名" required>
                            <el-input style="width:200px" v-model="form.staffName" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="授权系统用户">
                            <el-input style="width:200px" v-model="form.loginName" placeholder="请选择系统用户" @click.native="selUser" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="英文名">
                            <el-input style="width:200px" v-model="form.staffNameEn" placeholder="请输入英文名"></el-input>
                        </el-form-item>
                        <el-form-item label="工号" required>
                            <el-input style="width:200px" v-model="form.staffNo" placeholder="请输入工号"></el-input>
                        </el-form-item>
                        <el-form-item label="部门" required>
                            <selectTree  v-model="tree_model" :rowKeys="treekeys" :tree-data="treeData" :isMulti="false"
                                        placeholder="请选择部门"></selectTree>
                        </el-form-item>
                        <el-form-item label="职责">
                            <el-input style="width:200px" v-model="form.functions" placeholder="请输入职责"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input style="width:200px" v-model="form.tel" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱">
                            <el-input style="width:200px" v-model="form.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-select v-model="form.sex" placeholder="请选择性别" style="width: 200px">
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="出生日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.birthday"
                                            value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
                        </el-form-item>

                        <el-form-item label="民族">
                            <el-input style="width:200px" v-model="form.nation" placeholder="请输入民族"></el-input>
                        </el-form-item>
                        <el-form-item label="岗位类别">
                            <el-input style="width:200px" v-model="form.jobType" placeholder="请输入岗位类别"></el-input>
                        </el-form-item>
                        <el-form-item label="参加工作时间">
                            <el-input style="width:200px" v-model="form.jobJoinTime" placeholder="请输入参加工作时间"></el-input>
                        </el-form-item>

                        <el-form-item label="籍贯">
                            <el-input style="width:200px" v-model="form.fAddress" placeholder="请输入籍贯"></el-input>
                        </el-form-item>
                        <el-form-item label="政治面貌">
                            <el-input style="width:200px" v-model="form.political" placeholder="请输入政治面貌"></el-input>
                        </el-form-item>
                        <el-form-item label="入团日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.pJoinTime"
                                            value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="身份证号">
                            <el-input style="width:200px" v-model="form.sfid" placeholder="请输入身份证号"></el-input>
                        </el-form-item>
                        <el-form-item label="婚姻状况">
                            <el-select v-model="form.marital" placeholder="请选择婚姻状况" style="width: 200px">
                                <el-option label="已婚" value="已婚"></el-option>
                                <el-option label="未婚" value="未婚"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="进单位日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.dJoinTime"
                                            value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="现岗位">
                            <el-input style="width:200px" v-model="form.post" placeholder="请输入现岗位"></el-input>
                        </el-form-item>
                        <el-form-item label="上岗日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.poJoinTime"
                                            value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="学历">
                            <el-input style="width:200px" v-model="form.education" placeholder="请输入学历"></el-input>
                        </el-form-item>

                        <el-form-item label="毕业学校">
                            <el-input style="width:200px" v-model="form.school" placeholder="请输入毕业学校"></el-input>
                        </el-form-item>
                        <el-form-item label="专业">
                            <el-input style="width:200px" v-model="form.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item label="职称">
                            <el-input style="width:200px" v-model="form.ftitle" placeholder="请输入职称"></el-input>
                        </el-form-item>

                        <el-form-item label="职业资格证">
                            <el-input style="width:200px" v-model="form.certificate" placeholder="请输入职业资格证"></el-input>
                        </el-form-item>
                        <el-form-item label="劳动合同年限">
                            <el-input style="width:200px" v-model="form.contractYear" placeholder="请输入劳动合同年限"></el-input>
                        </el-form-item>
                        <el-form-item label="签订日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.cStartDate"
                                            value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="终止日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.cEndDate"
                                            value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="现住址">
                            <el-input style="width:200px" v-model="form.address" placeholder="请输入住址"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" class="bzClass">
                            <el-input
                                    style="width: 860px"
                                    resize="none"
                                    type="textarea"
                                    placeholder="请输入备注"
                                    v-model="form.remark"
                                    rows="2"
                                    show-word-limit>
                            </el-input>
                        </el-form-item>

                    </el-form>

                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label">
                        <i class="el-icon-paperclip"></i>  附件上传
                    </span>
                    <fileupload :fileUrl="fileUrl" :fileParam="fileParam" :fileListUrl="fileListUrl" :delFileUrl="delFileUrl" :fileKey="fileKey"></fileupload>
                </el-tab-pane>
            </el-tabs>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
        <selUser v-if="showUser"
                 :roleData="loginName"
                 @closeDialog="closeDialog"
                 @checkRow="checkUser">
        </selUser>
    </el-dialog>
</template>

<script>
    import selectTree from '@/components/tools/tree/selectTree'
    import selUser from '@/components/system/usermanage/userSelect/single'
    import fileupload from '@/components/tools/fileupload'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {selectTree,selUser,fileupload},
        data() {
            return {
                activeName: "first",
                loginName:"",
                showUser:false,
                tree_model: {
                    id: this.formData.p_id,
                    name: this.formData.p_name
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'parentId',
                    children: 'children'
                },
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
                fileKey:"staffFileId",
                fileUrl:"/stafffile/uploadFiles",
                fileListUrl:"/stafffile/getStaffFile",
                delFileUrl:"/stafffile/delete",
                fileParam:{
                    staffId:this.formData.staffId
                }
            };
        },
        mounted() {
            this.getFolder();
            this.tree_model = {
                id: this.formData.departmentId,
                name: this.formData.departmentName
            }
        },
        methods: {
            async getFolder() {
                this.dialoading = true;
                let param = {
                    url:"/department/listZTree",
                    param:{
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                const retData = data.data.jsonStr;
                this.treeData = retData

                this.dialoading = false;
            },
            closeDialog() {
                this.showUser = false;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            selUser(){
                this.loginName=this.form.loginName;
                this.showUser = true;
            },
            checkUser(row) {
                this.form.loginName = row.loginName;
                this.showUser = false;
            },
            async submitForm() {
                this.form.departmentId = this.tree_model.id;
                this.form.departmentName = this.tree_model.name;

                if(this.$pub.isEmpty(this.form.departmentName)){
                    this.$message({message: '请选择部门', type: 'error'});
                    return false;
                }
                if(this.$pub.isEmpty(this.form.staffName)){
                    this.$message({message: '请输入员工姓名', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },
        }
    }
</script>

